module.exports = __webpack_public_path__ + "static/media/Goodnest_ios_1.139efa5f.jpg";